import React, {useEffect, useRef, useState} from 'react';
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {useCreateCheckoutMutation} from "../services/endpoints/purchase.api";
import './CardComponent.css';
function CardComponent({ title, price, minutes, name, index }) {
    const navigate = useNavigate();
    const [createCheckout, { isLoading }] = useCreateCheckoutMutation(); // Hook RTK

    const token = useSelector((state) => state.userAuth.token);

    const cardRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.disconnect(); // stop observing after it appears
                }
            },
            { threshold: 0.1 }
        );

        if (cardRef.current) {
            observer.observe(cardRef.current);
        }

        return () => observer.disconnect();
    }, []);
    const handleClick = async (id) => {
        const price = ['prod_TAUiW0W06BXA4D','prod_TAUjmER6YvOuvG','prod_TAUoMXG2qi0hzn']
        try {
            if (token) {
                const result = await createCheckout({
                    id: price[id],
                    promo: false,
                    promoDescription: 'false'
                }).unwrap()
                window.open(result.url)
            } else {
                // Utente non loggato
                navigate('/login');
            }
        }catch (err) {
            // if(err.data) {
                console.log(err)
            // }
        }
    };
    return (
        <div       ref={cardRef}
                    className={`col-xs-12 col-sm-4 col-lg-4 mb-4 card-animate ${isVisible ? 'visible' : ''}`} >
            <div className="pricingTable pricingTable-2" style={{borderRadius:'30px', border: "1px solid"}}>
                <div className="pricingTable-header">
                    <h3 className="title">{title}</h3>
                    <h5 className="price-month">{name}</h5>
                    <h1 className="price-value">{price}€<span className="value-bg">{price}€</span></h1>
                </div>
                <ul className="pricing-content">
                    <li>{minutes} minuti</li>
                    <li>Messaggi testuali e vocali</li>
                    <li>Chat personale con operatore</li>
                    <li>Chats illimitate</li>
                    <li>Storico chats</li>
                    <li>Supporto Illimitato</li>
                </ul>
                <button onClick={() => handleClick(index)} className="btn btn-primary mt-auto" disabled={isLoading}>
                    {token ? isLoading ? "Creazione..." : "Acquista" : "Registrati / Accedi"}
                </button>
            </div>
        </div>
        // <div className="col-md-4 mb-4">
        //     <div className="card text-white bg-dark h-100 shadow">
        //         <div className="card-body d-flex flex-column justify-content-between">
        //             <h5 className="card-title">{title}</h5>
        //             <p className="card-text display-6">{price}€</p>
        //             <p className="card-text text-muted">{minutes} minuti</p>
        //             <button onClick={handleClick} className="btn btn-primary mt-auto" disabled={isLoading}>
        //                 {token ? isLoading ? "Creazione..." : "Acquista" : "Registrati / Accedi"}
        //             </button>
        //         </div>
        //     </div>
        // </div>
    );
}

export default CardComponent;
